<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keyup.enter="searchExportSheet" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสชีท"
                        aria-label="Search"
                        v-model="search.code"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchExportSheet">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสชีท</th>
                    <th scope="col">ชีท</th>
                    <th scope="col">ประเภทชีท</th>
                    <th scope="col">จำนวนชีทนำออก</th>
                    <th scope="col">ผู้เบิก</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">วัน/เวลาที่นำเข้า</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in export_sheet">
                    <td>
                        <template v-if="data.sheet">
                            {{ data.sheet.code }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sheet">
                            {{ data.sheet.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sheet.sheet_type">
                            {{ data.sheet.sheet_type.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.reason }}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <td>
                        <a @click="showExportSheet(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="export_sheet.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSheetExportPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- Modal Delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteExportSheet">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal edit Data -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำเข้าวัตถุดิบ">
            <div v-if="replace_sheet.sheet">
                <b-row sm="10">
                    <b-col sm="4" class="col text-right"
                    ><label>รหัสชีท</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="replace_sheet.sheet.code" disabled/></b-col>
                </b-row>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right"><label>ชีท</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="replace_sheet.sheet.name" disabled/></b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>จำนวนชีทนำออก</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="text"
                        v-model="replace_sheet.quantity"/></b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
                    <b-col sm="6">
                        <textarea
                            class="form-control"
                            v-model="replace_sheet.reason">
                        </textarea>
                    </b-col>
                </b-row>
                <br>
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveExportSheet">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button
                            type="button"
                            class="btn btn-danger"
                            @click="hideEditModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
            <!--<pre class="alert alert-primary">{{ replace_sheet }}</pre>-->
        </b-modal>
        <!--<pre class="alert alert-primary">{{ export_sheet }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment"

export default {
    name: "sheet-export",
    components: {
        VuePagination,
        DatePicker,
        Multiselect
    },
    created() {
        this.$store.dispatch("ExportSheet/get");
        this.$store.dispatch("Sheet/getSheetTYPE");
    },
    data() {
        return {
            dateFormat: 'D MMM YYYY',
            dateOne: '',
            search: {
                code: "",
                date: ""
            },
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            export_sheet: state => {
                return state.ExportSheet.table;
            },
            replace_sheet: state => {
                return state.ExportSheet.replace_data;
            },
            user: state => {
                return state.Auth.user;
            },
            optionSheetType: state => {
                return state.Sheet.sheet_type;
            },
            dataPaginate: state => {
                return state.ExportSheet.dataPaginate;
            }
        })
    },
    methods: {
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },

        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },
        //API
        showExportSheet(id) {
            this.showEditModal(id);
            this.$store.dispatch("ExportSheet/show", id);
        },
        deleteExportSheet() {
            this.$store.dispatch("ExportSheet/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("ExportSheet/get");
            });
        },
        saveExportSheet() {
            if (this.replace_sheet.quantity < 1 || this.replace_sheet.sheet.quantity < this.replace_sheet.quantity) {
                alert("กรุณาใส่จำนวนให้ถูกต้อง");
            } else {
                let data = {
                    sheet_id: this.replace_sheet.sheet_id,
                    quantity: this.replace_sheet.quantity,
                    reason: this.replace_sheet.reason,
                    user_id: this.user.id
                };
                this.$store.dispatch("ExportSheet/update", {
                    id: this.id,
                    data: data
                })
                    .then(data => {
                        if (!data) {
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        } else {
                            this.hideEditModal();
                            this.$store.dispatch("ExportSheet/get");
                        }
                    });
            }
        },
        searchExportSheet() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = ""
            }
            this.$store.dispatch("ExportSheet/search", {
                code: this.search.code,
                date: this.search.date
            });
        },
        getSheetExportPage() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = ""
            }
            if (this.event_submit) {
                this.$store.dispatch("ExportSheet/search", {
                    page: page,
                    code: this.search.code,
                    date: this.search.date
                });
            } else {
                this.$store.dispatch('ExportSheet/get', page);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
/*td:nth-of-type(1):before {*/
/*content: "รหัสชีท";*/
/*}*/
/*td:nth-of-type(2):before {*/
/*content: "ชีท";*/
/*}*/
/*td:nth-of-type(3):before {*/
/*content: "ประเภทชีท";*/
/*}*/
/*td:nth-of-type(4):before {*/
/*content: "จำนวนชีทนำออก";*/
/*}*/
/*td:nth-of-type(5):before {*/
/*content: "ผู้เบิก";*/
/*}*/
/*td:nth-of-type(6):before {*/
/*content: "หมายเหตุ";*/
/*}*/
/*td:nth-of-type(7):before {*/
/*content: "วัน/เวลาที่นำเข้า";*/
/*}*/
/*td:nth-of-type(8):before {*/
/*content: "แก้ไข / ลบ";*/
/*}*/
</style>
